// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/file_tree.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/file_tree.proto.
 */
export const file_pull_requests_v1_file_tree: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/file_tree
 *
 * Defined by PullRequests::PageData::SharedController#file_tree.
 *
 * @generated from message github.pull_requests.v1.FileTreeResponse
 */
export type FileTreeResponse = Message<"github.pull_requests.v1.FileTreeResponse"> & {
  /**
   * @generated from field: string base_ref_oid = 1;
   */
  baseRefOid: string;

  /**
   * @generated from field: repeated github.pull_requests.v1.FileTreeCommit commits = 2;
   */
  commits: FileTreeCommit[];

  /**
   * @generated from field: repeated github.pull_requests.v1.DiffSummary diffs = 3;
   */
  diffs: DiffSummary[];

  /**
   * Omitted when the pull request has no last-reviewed commit (legacy JSON null).
   *
   * @generated from field: string last_review_oid = 4;
   */
  lastReviewOid: string;

  /**
   * @generated from field: string owner_login = 5;
   */
  ownerLogin: string;

  /**
   * @generated from field: string path_name = 6;
   */
  pathName: string;

  /**
   * Opaque global relay id (e.g. "PR_kwD..."); a string, not a numeric id.
   *
   * @generated from field: string pull_request_id = 7;
   */
  pullRequestId: string;

  /**
   * @generated from field: int32 pull_request_number = 8;
   */
  pullRequestNumber: number;

  /**
   * @generated from field: string repository_name = 9;
   */
  repositoryName: string;
};

/**
 * Describes the message github.pull_requests.v1.FileTreeResponse.
 * Use `create(FileTreeResponseSchema)` to create a new message.
 */
export const FileTreeResponseSchema: GenMessage<FileTreeResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_tree, 0);

/**
 * A commit shown in the file tree's commit range selector.
 *
 * @generated from message github.pull_requests.v1.FileTreeCommit
 */
export type FileTreeCommit = Message<"github.pull_requests.v1.FileTreeCommit"> & {
  /**
   * @generated from field: string actor_login = 1;
   */
  actorLogin: string;

  /**
   * ISO8601
   *
   * @generated from field: string created_at = 2;
   */
  createdAt: string;

  /**
   * @generated from field: string message_headline = 3;
   */
  messageHeadline: string;

  /**
   * @generated from field: string oid = 4;
   */
  oid: string;

  /**
   * @generated from field: string short_oid = 5;
   */
  shortOid: string;
};

/**
 * Describes the message github.pull_requests.v1.FileTreeCommit.
 * Use `create(FileTreeCommitSchema)` to create a new message.
 */
export const FileTreeCommitSchema: GenMessage<FileTreeCommit> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_tree, 1);

/**
 * Per-file diff summary shown in the file tree.
 *
 * @generated from message github.pull_requests.v1.DiffSummary
 */
export type DiffSummary = Message<"github.pull_requests.v1.DiffSummary"> & {
  /**
   * @generated from field: github.pull_requests.v1.ChangeType change_type = 1;
   */
  changeType: ChangeType;

  /**
   * @generated from field: bool is_codeowner = 2;
   */
  isCodeowner: boolean;

  /**
   * @generated from field: bool is_manifest_file = 3;
   */
  isManifestFile: boolean;

  /**
   * @generated from field: bool is_vendored = 4;
   */
  isVendored: boolean;

  /**
   * @generated from field: int32 lines_added = 5;
   */
  linesAdded: number;

  /**
   * @generated from field: int32 lines_changed = 6;
   */
  linesChanged: number;

  /**
   * @generated from field: int32 lines_deleted = 7;
   */
  linesDeleted: number;

  /**
   * @generated from field: bool marked_as_viewed = 8;
   */
  markedAsViewed: boolean;

  /**
   * @generated from field: string path = 9;
   */
  path: string;

  /**
   * @generated from field: string path_digest = 10;
   */
  pathDigest: string;

  /**
   * @generated from field: github.pull_requests.v1.AnnotationLevel highest_annotation_level = 11;
   */
  highestAnnotationLevel: AnnotationLevel;

  /**
   * Keyed by serialized marker position: "FILE", "L<line>" (left side), or
   * "R<line>" (right side).
   *
   * @generated from field: map<string, github.pull_requests.v1.MarkerCollection> markers_map = 12;
   */
  markersMap: { [key: string]: MarkerCollection };

  /**
   * @generated from field: bool is_symlink = 13;
   */
  isSymlink: boolean;
};

/**
 * Describes the message github.pull_requests.v1.DiffSummary.
 * Use `create(DiffSummarySchema)` to create a new message.
 */
export const DiffSummarySchema: GenMessage<DiffSummary> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_tree, 2);

/**
 * Review threads and check annotations anchored at a marker position.
 *
 * @generated from message github.pull_requests.v1.MarkerCollection
 */
export type MarkerCollection = Message<"github.pull_requests.v1.MarkerCollection"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.Marker threads = 1;
   */
  threads: Marker[];

  /**
   * @generated from field: repeated github.pull_requests.v1.Marker annotations = 2;
   */
  annotations: Marker[];

  /**
   * Context injection range as [first_line, last_line]; omitted when absent.
   *
   * @generated from field: repeated int32 ctx = 3;
   */
  ctx: number[];
};

/**
 * Describes the message github.pull_requests.v1.MarkerCollection.
 * Use `create(MarkerCollectionSchema)` to create a new message.
 */
export const MarkerCollectionSchema: GenMessage<MarkerCollection> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_tree, 3);

/**
 * @generated from message github.pull_requests.v1.Marker
 */
export type Marker = Message<"github.pull_requests.v1.Marker"> & {
  /**
   * Review thread / annotation database id. int64 because ids exceed 2^31;
   * serializes as a JSON string in proto3 JSON.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * Serialized start position of a multi-line range (e.g. "L12"/"R34");
   * omitted for single-line markers.
   *
   * @generated from field: string start = 2;
   */
  start: string;

  /**
   * Reason a review thread is outdated; omitted when not outdated.
   *
   * @generated from field: string outdated_reason = 3;
   */
  outdatedReason: string;
};

/**
 * Describes the message github.pull_requests.v1.Marker.
 * Use `create(MarkerSchema)` to create a new message.
 */
export const MarkerSchema: GenMessage<Marker> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_file_tree, 4);

/**
 * Change type of a diff entry. Serializes as the UPPER_SNAKE_CASE enum value
 * name (e.g. CHANGE_TYPE_ADDED); the client maps it back to its PatchStatus.
 * The legacy JSON encoded this as the bare status string ("ADDED"/"MODIFIED").
 *
 * @generated from enum github.pull_requests.v1.ChangeType
 */
export enum ChangeType {
  /**
   * @generated from enum value: CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANGE_TYPE_ADDED = 1;
   */
  ADDED = 1,

  /**
   * @generated from enum value: CHANGE_TYPE_CHANGED = 2;
   */
  CHANGED = 2,

  /**
   * @generated from enum value: CHANGE_TYPE_COPIED = 3;
   */
  COPIED = 3,

  /**
   * @generated from enum value: CHANGE_TYPE_DELETED = 4;
   */
  DELETED = 4,

  /**
   * @generated from enum value: CHANGE_TYPE_EMPTY = 5;
   */
  EMPTY = 5,

  /**
   * @generated from enum value: CHANGE_TYPE_MODIFIED = 6;
   */
  MODIFIED = 6,

  /**
   * @generated from enum value: CHANGE_TYPE_REMOVED = 7;
   */
  REMOVED = 7,

  /**
   * @generated from enum value: CHANGE_TYPE_RENAMED = 8;
   */
  RENAMED = 8,

  /**
   * @generated from enum value: CHANGE_TYPE_UNCHANGED = 9;
   */
  UNCHANGED = 9,
}

/**
 * Describes the enum github.pull_requests.v1.ChangeType.
 */
export const ChangeTypeSchema: GenEnum<ChangeType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_file_tree, 0);

/**
 * Highest check-annotation level on a diff entry. UNSPECIFIED represents the
 * legacy JSON null (no annotations). Serializes as UPPER_SNAKE_CASE
 * (e.g. ANNOTATION_LEVEL_FAILURE); the legacy JSON used the bare level string.
 *
 * @generated from enum github.pull_requests.v1.AnnotationLevel
 */
export enum AnnotationLevel {
  /**
   * @generated from enum value: ANNOTATION_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ANNOTATION_LEVEL_NOTICE = 1;
   */
  NOTICE = 1,

  /**
   * @generated from enum value: ANNOTATION_LEVEL_WARNING = 2;
   */
  WARNING = 2,

  /**
   * @generated from enum value: ANNOTATION_LEVEL_FAILURE = 3;
   */
  FAILURE = 3,
}

/**
 * Describes the enum github.pull_requests.v1.AnnotationLevel.
 */
export const AnnotationLevelSchema: GenEnum<AnnotationLevel> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_file_tree, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(FileTreeResponseSchema, "ae4d2b88f862")
registerSchemaHash(FileTreeCommitSchema, "5b60e9f4acea")
registerSchemaHash(DiffSummarySchema, "934918631b7f")
registerSchemaHash(MarkerCollectionSchema, "54e5359534ff")
registerSchemaHash(MarkerSchema, "36ec9a177818")
